/**
 * 用户注册策略（与后端 application.yml `user.register` 保持一致）。
 * 恢复邀请码注册：改为 true，并同步后端 require-invite-code: true
 */
export const REGISTER_REQUIRE_INVITE_CODE = false

/**
 * @returns {{ ok: boolean, message?: string, value: string }}
 */
export function validateInviteCodeForRegister(inviteCode) {
  if (!REGISTER_REQUIRE_INVITE_CODE) {
    return { ok: true, value: '' }
  }

  const trimmed = (inviteCode || '').trim()
  if (!trimmed) {
    return { ok: false, message: '请输入邀请码', value: '' }
  }
  if (trimmed.length < 6 || trimmed.length > 64) {
    return { ok: false, message: '邀请码长度需在6-64位之间', value: '' }
  }
  if (!/^[a-zA-Z0-9-]+$/.test(trimmed)) {
    return { ok: false, message: '邀请码只能包含字母、数字或连字符', value: '' }
  }
  return { ok: true, value: trimmed }
}

export function buildRegisterInviteCodePayload(inviteCode) {
  const result = validateInviteCodeForRegister(inviteCode)
  if (!REGISTER_REQUIRE_INVITE_CODE) {
    return undefined
  }
  return result.value
}
